import http from 'plugins/axios';

export default {
    getMachineStrategyAllConfig(data) {
        return http.get({
            url: '/admin/machine/strategy/getAllConfig',
            data
        });
    },
    updateBingshanConfig(data) {
        return http.post({
            url: '/admin/machine/strategy/bingshan/update',
            data,
            dataType: 'form'
        });
    },
    updateBingshanStatus(data) {
        return http.post({
            url: '/admin/machine/strategy/bingshan/statusUpdate',
            data,
            dataType: 'form'
        });
    },
    updateStockTradeAtRegularTimeConfig(data) {
        return http.post({
            url: '/admin/machine/strategy/stockTrade/update',
            data,
            dataType: 'form'
        });
    },
    updateStockTradeStatus(data) {
        return http.post({
            url: '/admin/machine/strategy/stockTrade/statusUpdate',
            data,
            dataType: 'form'
        });
    },
    updateReverseConfig(data) {
        return http.post({
            url: '/admin/machine/strategy/reverse/update',
            data,
            dataType: 'form'
        });
    },
    updateReverseStatus(data) {
        return http.post({
            url: '/admin/machine/strategy/reverse/statusUpdate',
            data,
            dataType: 'form'
        });
    },
    updateTradersCreateConf(data) {
        return http.post({
            url: '/admin/machine/strategy/spread/updateCreateConf',
            data,
            dataType: 'form'
        });
    },
    updateTradersCancelConf(data) {
        return http.post({
            url: '/admin/machine/strategy/spread/updateCancelConf',
            data,
            dataType: 'form'
        });
    },
    executeSpreadOrCancelOrder(data) {
        return http.post({
            url: '/admin/machine/strategy/spread/execute',
            data,
            dataType: 'form'
        });
    },
    updateActiveConfig(data) {
        return http.post({
            url: '/admin/machine/strategy/active/update',
            data,
            dataType: 'form'
        });
    },
    updateActiveStatus(data) {
        return http.post({
            url: '/admin/machine/strategy/active/statusUpdate',
            data,
            dataType: 'form'
        });
    },
    getAllPair() {
        return http.get({
            url: '/admin/tradePair/allDisplay'
        });
    },
    getOrder(data) {
        return http.get({
            url: '/admin/traders/orders',
            data
        });
    },
    getDetails(data) {
        return http.get({
            url: '/admin/traders/details',
            data
        });
    },

};
